var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1H13.8889C16.378 1 17.6226 1 18.5733 1.48442C19.4096 1.91052 20.0895 2.59043 20.5156 3.42671C21 4.37743 21 5.62199 21 8.11111V16M4.55556 21H13.5556C14.8001 21 15.4224 21 15.8978 20.7578C16.3159 20.5447 16.6559 20.2048 16.8689 19.7866C17.1111 19.3113 17.1111 18.689 17.1111 17.4444V8.44444C17.1111 7.19988 17.1111 6.5776 16.8689 6.10224C16.6559 5.68411 16.3159 5.34415 15.8978 5.1311C15.4224 4.88889 14.8001 4.88889 13.5556 4.88889H4.55556C3.31099 4.88889 2.68871 4.88889 2.21335 5.1311C1.79522 5.34415 1.45526 5.68411 1.24221 6.10224C1 6.5776 1 7.19988 1 8.44444V17.4444C1 18.689 1 19.3113 1.24221 19.7866C1.45526 20.2048 1.79522 20.5447 2.21335 20.7578C2.68871 21 3.31099 21 4.55556 21Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyMessage);
export default __webpack_public_path__ + "static/media/copy_message.4676291cba55960d2107289db6cde041.svg";
export { ForwardRef as ReactComponent };